<template>
  <b-row>
    <b-col
      v-for="(counter,index) in counters"
      :key="index"
    >
      <counter-item :data-item="counter" />
    </b-col>
  </b-row>
</template>
<script>
import { BRow, BCol } from 'bootstrap-vue'
import CounterItem from '@/views/Dashboard/Counters/CounterItem.vue'

export default {
  name: 'Counters',
  components: {
    BRow,
    BCol,
    CounterItem,
  },
  computed: {
    counters() {
      return this.$store.getters['dashboard/counters']
    },
    counters2() {
      return [
        {
          color: 'light-primary', icon: 'CodesandboxIcon', label: 'Ürünler', value: 125, url: '',
        },
        {
          color: 'light-success', icon: 'CropIcon', label: 'Projeler', value: 44, url: '',
        },
        {
          color: 'light-info', icon: 'CoffeeIcon', label: 'Hizmetler', value: 18, url: '',
        },
      ]
    },
  },
}
</script>
